document.addEventListener('DOMContentLoaded', function () {

  // Drawer Menu Toggle
  var toggle = document.querySelector('.nav-toggle');
  var drawer = document.querySelector('.menu-drawer');
  var overlay = document.querySelector('.menu-overlay');
  var closeBtn = document.querySelector('.menu-close');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if(toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if(toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && drawer) {
    toggle.addEventListener('click', openDrawer);
    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if(overlay) overlay.addEventListener('click', closeDrawer);
  }

  // Search Modal Toggle
  var searchToggle = document.querySelector('.search-toggle');
  var searchModal = document.querySelector('.search-modal');
  var searchClose = document.querySelector('.search-close');
  var searchInput = document.querySelector('.search-input');

  function openSearch() {
    searchModal.classList.add('is-open');
    setTimeout(() => { if(searchInput) searchInput.focus(); }, 100);
  }
  function closeSearch() {
    searchModal.classList.remove('is-open');
  }

  if (searchToggle && searchModal) {
    searchToggle.addEventListener('click', openSearch);
    if(searchClose) searchClose.addEventListener('click', closeSearch);
  }

  // Account Popover Toggle
  var accountToggle = document.querySelector('.account-toggle');
  var accountPopover = document.querySelector('.account-popover');
  var accountClose = document.querySelector('.account-close');

  function toggleAccount() {
    accountPopover.classList.toggle('is-open');
  }

  if (accountToggle && accountPopover) {
    accountToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      accountPopover.classList.toggle('is-open');
    });
    
    if(accountClose) {
      accountClose.addEventListener('click', function(e) {
        e.stopPropagation();
        accountPopover.classList.remove('is-open');
      });
    }
    
    // Close popover when clicking outside
    document.addEventListener('click', function(event) {
      if (accountPopover.classList.contains('is-open') && !accountPopover.contains(event.target)) {
        accountPopover.classList.remove('is-open');
      }
    });
  }

  // Predictive Search Logic
  var searchInputEl = document.getElementById('SearchInput');
  var predictiveResultsEl = document.getElementById('PredictiveResults');
  var debounceTimer;

  if (searchInputEl && predictiveResultsEl) {
    searchInputEl.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = searchInputEl.value.trim();
      
      if (query.length < 2) {
        predictiveResultsEl.classList.remove('is-active');
        predictiveResultsEl.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
          .then(response => response.json())
          .then(data => {
            var products = data.resources.results.products;
            if (products && products.length > 0) {
              var html = '<div class="predictive-grid">';
              products.forEach(function(product) {
                html += '<a href="' + product.url + '" class="predictive-item">';
                if (product.image) {
                  html += '<img src="' + product.image + '" alt="' + product.title + '" class="predictive-image">';
                }
                html += '<span class="predictive-title">' + product.title + '</span>';
                html += '<span class="predictive-price">' + product.price + '</span>';
                html += '</a>';
              });
              html += '</div>';
              predictiveResultsEl.innerHTML = html;
            } else {
              predictiveResultsEl.innerHTML = '<p class="predictive-empty">No se encontraron productos para "' + query + '"</p>';
            }
            predictiveResultsEl.classList.add('is-active');
          })
          .catch(error => {
            console.error('Error fetching predictive search:', error);
          });
      }, 300); // 300ms debounce
    });
  }

  // Quantity steppers (product page + cart page)
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input[type="number"]');
    var minus = stepper.querySelector('.qty-minus');
    var plus = stepper.querySelector('.qty-plus');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10);
        var val = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 0) + 1;
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  // Product and Featured Carousel Navigation
  var pdpCarousel = document.getElementById('ProductCarousel');
  var pdpPrev = document.querySelector('.carousel-prev');
  var pdpNext = document.querySelector('.carousel-next');

  if (pdpCarousel) {
    if (pdpPrev) {
      pdpPrev.addEventListener('click', function() {
        pdpCarousel.scrollBy({ left: -pdpCarousel.offsetWidth, behavior: 'smooth' });
      });
    }
    if (pdpNext) {
      pdpNext.addEventListener('click', function() {
        pdpCarousel.scrollBy({ left: pdpCarousel.offsetWidth, behavior: 'smooth' });
      });
    }
  }

  // Variant selection (Pills & Selects fallback)
  function initProductForm(formEl) {
    if (!formEl) return;
    var section = formEl.closest('.shopify-section');
    var jsonScript = section ? section.querySelector('script[id^="ProductJson-"]') : document.querySelector('script[id^="ProductJson-"]');
    var inventoryScript = section ? section.querySelector('script[id^="VariantInventory-"]') : document.querySelector('script[id^="VariantInventory-"]');
    var variantIdInput = formEl.querySelector('[name="id"]');
    var priceEl = section ? section.querySelector('.pdp-price') : null;
    var stockWarning = section ? section.querySelector('.low-stock-warning') : null;
    var stockCount = section ? section.querySelector('.stock-count') : null;
    
    // We now use radio buttons instead of selects
    var optionRadios = formEl.querySelectorAll('.pdp-option-radio');

    if (jsonScript && variantIdInput) {
      var product = JSON.parse(jsonScript.textContent);
      var inventoryMap = inventoryScript ? JSON.parse(inventoryScript.textContent) : {};

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: product.price_varies ? 'EUR' : (window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR') });
      }

      function currentSelection() {
        var values = [];
        // Assuming up to 3 options
        for (var i = 1; i <= 3; i++) {
          var checkedRadio = formEl.querySelector('.pdp-option-radio[data-position="' + i + '"]:checked');
          if (checkedRadio) values.push(checkedRadio.value);
        }
        return values;
      }

      function findVariant(values) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      function updateForSelection() {
        if (optionRadios.length === 0) return;
        var variant = findVariant(currentSelection());
        if (!variant) return;
        
        variantIdInput.value = variant.id;
        
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
            ? '<s>' + formatMoney(variant.compare_at_price) + '</s> ' + formatMoney(variant.price)
            : formatMoney(variant.price);
        }
        
        var addBtn = formEl.querySelector('.pdp-add');
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Añadir a la cesta' : 'Agotado';
        }

        // Low stock warning
        var stock = inventoryMap[variant.id];
        if (stockWarning && stock !== undefined) {
          if (stock > 0 && stock < 3) {
            stockCount.textContent = stock;
            stockWarning.style.display = 'block';
          } else {
            stockWarning.style.display = 'none';
          }
        }

        // Marcar pills agotados
        optionRadios.forEach(function (radio) {
          var tempValues = currentSelection();
          var posIndex = parseInt(radio.getAttribute('data-position')) - 1;
          tempValues[posIndex] = radio.value;
          var tempVariant = findVariant(tempValues);
          
          if (tempVariant && !tempVariant.available) {
            radio.nextElementSibling.classList.add('is-sold-out');
          } else {
            radio.nextElementSibling.classList.remove('is-sold-out');
          }
        });
      }

      optionRadios.forEach(function (radio) {
        radio.addEventListener('change', updateForSelection);
      });
      
      // Init on load
      updateForSelection();
    }
  }

  // Initialize main product form
  var mainForm = document.getElementById('ProductForm');
  if (mainForm) initProductForm(mainForm);

  // Quick Add Logic
  var quickAddDrawer = document.getElementById('QuickAddDrawer');
  var quickAddOverlay = document.querySelector('.quick-add-drawer-overlay');
  var quickAddClose = document.querySelector('.quick-add-close');
  var quickAddContent = document.getElementById('QuickAddContent');

  function closeQuickAdd() {
    if(quickAddDrawer) quickAddDrawer.classList.remove('is-active');
    if(quickAddOverlay) quickAddOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (quickAddClose) quickAddClose.addEventListener('click', closeQuickAdd);
  if (quickAddOverlay) quickAddOverlay.addEventListener('click', closeQuickAdd);

  // Direct Add (1 variant)
  document.querySelectorAll('.quick-add-direct').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.getAttribute('data-variant-id');
      var originalText = this.textContent;
      this.textContent = 'Añadiendo...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => response.json())
      .then(data => {
        this.textContent = '¡Añadido!';
        setTimeout(() => { this.textContent = originalText; }, 2000);
        // Here you could trigger a mini-cart update
      })
      .catch(err => {
        console.error(err);
        this.textContent = 'Error';
      });
    });
  });

  // Modal Add (Multiple variants)
  document.querySelectorAll('.quick-add-modal-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var handle = this.getAttribute('data-product-handle');
      
      quickAddDrawer.classList.add('is-active');
      quickAddOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      quickAddContent.innerHTML = '<div class="loader">Cargando...</div>';

      fetch('/products/' + handle + '?section_id=main-product')
      .then(response => response.text())
      .then(html => {
        // Extraemos solo el HTML de la respuesta (Shopify devuelve un div wrapper)
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var pdpInfo = doc.querySelector('.pdp-info'); // Solo queremos la info y el form, no la foto grande
        
        // Extraemos una imagen para la mini-preview
        var imgElement = doc.querySelector('.pdp-gallery-carousel img, .pdp-media img');
        var imgSrc = imgElement ? imgElement.src : '';
        var productTitle = doc.querySelector('.pdp-info h1') ? doc.querySelector('.pdp-info h1').textContent : '';

        quickAddContent.innerHTML = '';
        
        if (pdpInfo) {
           // Insertamos la mini-preview antes de la info
           if (imgSrc) {
             var miniPreview = document.createElement('div');
             miniPreview.className = 'quick-add-mini-preview';
             miniPreview.innerHTML = '<img src="' + imgSrc + '" alt="preview">';
             quickAddContent.appendChild(miniPreview);
           }
           
           quickAddContent.appendChild(pdpInfo);
           var form = quickAddContent.querySelector('form');
           initProductForm(form); 
        } else {
           quickAddContent.innerHTML = '<p>Error cargando producto.</p>';
        }
      });
    });
  });
});
